import React from 'react';
import './BarChartComponent.css';
import {BarChart} from '@mui/x-charts/BarChart';
import {BarChartComponentProps} from "./BarChartComponent.props";
import { axisClasses } from '@mui/x-charts';

const BarChartComponent: React.FC<BarChartComponentProps> = (props) => {

  // const pData = [1, 1, 0, 1, 1, 0.1];
  // const uData = [1, 2, 1, 1, 3, 0.1];
  // const xLabels = [
  //   'Jan',
  //   'Feb',
  //   'Mar',
  //   'Apr',
  //   'May',
  //   'Jun'
  // ];
  // const series=[
  //   { data: pData, label: 'Emails Reported', id: 'pvId', color: '#244B77' },
  //   { data: uData, label: 'Courses Completed', id: 'uvId', color: '#9FD8DB'  },
  // ]

  return (
    <>
      <BarChart
        height={230}
        series={props?.series || []}
        xAxis={[{data: props?.xLabels, scaleType: 'band'}]}
        yAxis={[
          {
          ...props?.yAxisConfig
          }
        ]}
        margin={{top: 10, bottom: 80}}
        tooltip={{trigger: 'none'}} // turn off tooltip
        axisHighlight={{x: 'none', y: 'none'}} // remove highlight when hover
        slotProps={{
          axisLine: {y1: 0, y2: 0},
          axisTick: {x2: 0},
          axisTickLabel: {
            style: {fontSize: 12, fontWeight: 400}
          },
          legend: {
            classes: {
              root: 'custom-root',
              series: 'custom-series',
              mark: 'custom-mark',
            },
            position: {vertical: 'bottom', horizontal: 'middle'},
            direction: 'row',
            padding: {top: 50},
            labelStyle: {marginTop: '50px', gap: '50px'}
          },
        }}
        sx={{
          [`& .${axisClasses.line}`]: {
            stroke: '#CCCFCF !important',
          },
          '& .MuiChartsAxis-tick': {
            stroke: '#CCCFCF !important',
          },
        }}
      />
    </>
  );
};

export default BarChartComponent;
